<template>
  <div>
    <div class="passwordHeader">
      <div @click="backBtn" v-if="!reSameInput">
        <a class="backBtn">
          <span class='ico icoBack'></span>
        </a>
      </div>
      <h1 class="passwordHeaderTitle">비밀번호 변경</h1>
      <span class="closeBtn" @click="pwdToggleChange">닫기</span>
    </div>
    <div class="keypad-group">
      <p v-if="originPwd">비밀번호를 입력해 주세요</p>
      <p v-else-if="reSameInput">새롭게 사용하실<br><span>로그인 비밀번호</span>를 입력해주세요</p>
      <p v-else><span>동일하게 한번 더</span><br>숫자6자리를 입력해주세요</p>
      <KeyPad
        ref="pwd"
        class="keypad-input"
        :padSwitch="padSwitch"
        @firstPwd="firstPwd"
        @secondPwd="secondPwd"
      />
      <p v-show="confirmFaild" class="keypad-fail">{{ showResultMsg }}</p>
    </div>
  </div>
</template>

<script>
import KeyPad from '@/components/Common/KeyPad.vue'
import service from '@/backend/modnpay_app_api'
import { THROW_APP_ERROR, THROW_APP_LOGIN_OVER_LAP } from '@/router'
/* eslint-disable eqeqeq */
export default {
  components: {
    KeyPad
  },
  data () {
    return {
      originPwd: true, // 기존 비밀번호 입력
      padSwitch: true, // 비밀번호 input
      reSameInput: true, // 동일하게 한번 더
      showResultMsg: '', // 실패 메세지
      confirmFaild: false,
      perNo: '',
      passwd: ''
    }
  },
  mounted () {
    // window.backBtn = () => {
    //   this.backBtn()
    // }
  },
  methods: {
    backBtn () {
      // if (this.padSwitch == true) {
      //   this.pwdToggleChange()
      // } else {
      this.reSameInput = true
      this.padSwitch = true
      this.passwd = ''
      // }
    },
    pwdToggleChange () {
      this.$emit('pwdToggleChange')
    },
    firstPwd (value) {
      if (this.originPwd) {
        this.checkPasswd(value)
      } else {
        this.passwordValidationCheck(value)
      }
    },
    // 이전 비밀번호 확인
    async checkPasswd (value) {
      const req = {
        userCode: '',
        passwd: value
      }

      const { data } = await service.checkPasswd(req)
      const code = data.resultCode
      if (code == 0) {
        this.originPwd = false
        this.perNo = data.perNo
        this.confirmFaild = false
      } else {
        this.confirmFaild = true
        this.showResultMsg = data.resultMsg
      }
      this.$refs.pwd.passwd = ''
    },
    // 비밀번호 유효성체크
    async passwordValidationCheck (value) {
      const req = {
        perNo: this.perNo,
        passwd: value
      }

      const { data } = await service.passwordValidationCheck(req)
      const code = data.resultCode
      if (code == 0) {
        this.passwd = value
        this.padSwitch = false
        this.reSameInput = !this.reSameInput
        this.confirmFaild = false
      } else {
        this.confirmFaild = true
        this.showResultMsg = data.resultMsg
      }
      this.$refs.pwd.passwd = ''
    },
    // 비밀번호 일치 확인
    async secondPwd (value) {
      const req = {
        passwd: this.passwd,
        confirmPasswd: value
      }
      const { data } = await service.confirmPasswd(req)
      const code = data.resultCode
      if (code == 0) {
        this.changePasswd(value)
      } else {
        this.confirmFaild = true
        this.showResultMsg = data.resultMsg
        this.$refs.pwd.confirmPasswd = ''
      }
    },
    // 비밀번호 변경
    async changePasswd (value) {
      const req = {
        userCode: '',
        passwd: value
      }

      const { data } = await service.changePasswd(req)
      const code = data.resultCode
      if (code == 0) {
        localStorage.setItem('encPasswd', data.encPasswd)
        this.$emit('showSingleBtnDialog', 21)
      } else if (code == 15033) {
        THROW_APP_LOGIN_OVER_LAP()
      } else {
        THROW_APP_ERROR()
      }
    }
  }
}
</script>

<style scoped>
</style>
